// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2JgRL","row":"Node_row__2Xk1P","label":"Node_label__1cyWJ","footer":"Node_footer__hX3Au"};